import { Fragment } from "react";
import Footer from "./footers/Footer";
import Navbar from "./navbars/Navbar";
import WhatsappButton from "../components/WhatsappButton";
import ServiceBanner from "../components/our-services/ServiceBanner";

const ServicesLayout = ({ children }) => {
  return (
    <Fragment>
      <Navbar />
      <ServiceBanner />
      {children}
      <Footer />
      <WhatsappButton />
    </Fragment>
  );
};

export default ServicesLayout;
